export default __webpack_public_path__ + "static/media/rocket.1a9f4942.png";